import Select, { SingleValue } from "react-select"

import type { FC } from "react"

export type Option = {
  value: string
  label?: string
  payload?: any
}

type Props = {
  options: Option[]
  onChange: (option: SingleValue<Option>) => void
  value?: Option | null
  defaultValue?: Option | null
  label?: string
  placeholder?: string
  disabled?: boolean
  searchable?: boolean
  clearable?: boolean
  loading?: boolean
  className?: string
  menuPlacement?: "bottom" | "top" | "auto"
}

const Dropdown: FC<Props> = ({
  options,
  onChange,
  value,
  defaultValue,
  label,
  placeholder,
  disabled = false,
  searchable = false,
  className,
  clearable = false,
  loading,
  menuPlacement = "bottom"
}) => {
  return (
    <fieldset>
      {label && <legend>{label}</legend>}
      <Select
        value={value}
        onChange={onChange}
        defaultValue={defaultValue}
        placeholder={placeholder}
        options={options}
        isDisabled={disabled}
        isSearchable={searchable}
        className={className}
        isClearable={clearable}
        isLoading={loading}
        menuPlacement={menuPlacement}
        noOptionsMessage={() => <div>Нет данных</div>}
        theme={theme => ({
          ...theme,
          borderRadius: 4,
          colors: {
            ...theme.colors,
            primary25: "rgba(0,0,0,0.3)",
            primary: "rgba(0,0,0,0.8)"
          }
        })}
        styles={{
          control: base => ({
            ...base,
            height: 45,
            minHeight: 45
          })
        }}
      />
    </fieldset>
  )
}

export default Dropdown
